// Copyright (c) 2017 Deere & Company

import LaborRates from '../state/labor-rates';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const updateList = (state, action) =>
    LaborRates.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().dealers, action) => {

    const actionTypes = {
        [actions.SET_LABOR_RATE_DEALERS]: updateList
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/reducers/dealers.js